import { isTryOnMobile } from "../../../scripts/utils/utils";

const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const tryonGrid = tryonTemplateContainer?.querySelector('.to__glasses--grid');
const sectionId = tryonGrid?.dataset?.id;
const addToCartButton = tryonTemplateContainer?.querySelector('.to__add-to-cart .loader');
const tryOnGrid = tryonTemplateContainer?.querySelector('.to__glasses--grid');

if (!sectionId || !tryOnGrid) return;

function handleTryOnGridScroll() {
  const scrollPosition = tryOnGrid.scrollTop + tryOnGrid.clientHeight;
  const totalHeight = tryOnGrid.scrollHeight;

  if (totalHeight - scrollPosition <= 200) {
    tryOnGrid?.removeEventListener('scroll', handleTryOnGridScroll);
    initEventHandlers();
  }
}

tryOnGrid.addEventListener('scroll', handleTryOnGridScroll);

function initEventHandlers() {
  const nextPageEls = tryonTemplateContainer?.querySelectorAll('.to-load-more');
  const nextPageEl = nextPageEls[nextPageEls?.length - 1];
  if (!nextPageEl) return;
  const nextURL = nextPageEl.dataset.nextUrl;

  if (!nextURL) return;
  renderSectionFromFetch(nextURL);
}

async function renderSectionFromFetch(nextURL) {
  if (addToCartButton) addToCartButton.classList.add('loading');
  const isMobile = isTryOnMobile();

  try {
    const response = await fetch(nextURL);
    const html = await response.text();
    const parser = new DOMParser();
    const fetchedPage = parser.parseFromString(html, 'text/html')?.querySelector('body');

    const tryOnGridNew = fetchedPage?.querySelector('.to__glasses--grid');
    const fetchMoreLink = tryOnGrid?.querySelector('.to-load-more');
    const fetchMoreLinkNew = tryOnGridNew?.querySelector('.to-load-more')?.dataset.nextUrl;

    if (tryOnGridNew && !isMobile) tryOnGrid.innerHTML += tryOnGridNew.innerHTML;
    if (isMobile) fetchMoreLink?.setAttribute('data-next-url', fetchMoreLinkNew);
    if (addToCartButton) setTimeout(() => {
      addToCartButton.classList.remove('loading');
    }, 500);
    if (!isMobile) tryOnGrid.addEventListener('scroll', handleTryOnGridScroll);

    const detail = isMobile ? {
      newSlides: Array.from(tryOnGridNew?.children).map(child => child.outerHTML)
    } : {};
    const loadedGlassesEvent = new CustomEvent('try-on:loaded-glasses', { detail });
    document.dispatchEvent(loadedGlassesEvent);
  } catch (error) {
    console.error('Failed fetching more glasses');
  }
}

document.addEventListener('try-on:load-more-glasses', initEventHandlers);